import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { FeatureFlagsService } from './app/shared/services/featureflags/featureflags.service';

import { environment } from './environments/environment';

if (environment.production) {
	enableProdMode();
}

void (async () => {
	await FeatureFlagsService.ensureLoaded();
	platformBrowserDynamic()
		.bootstrapModule(AppModule, {
			applicationProviders: [provideZoneChangeDetection()],
		})
		.catch((err) => console.error(err));
})();
